export default {
      id: "menu__orchestrator-usage",
      viewBox: "0 0 27 28",
      url: __webpack_public_path__ + "img/icons.svg#menu__orchestrator",
      toString: function () {
        return this.url;
      }
    }